import { useEffect, useState } from "react";
import { Button, Container, Row, Col, Accordion, Form, Card, Modal } from "react-bootstrap";
import Transaccion from "../../components/tesoreria/transaccion";
import { useParams } from "react-router-dom";
import { deleteTransaction, getTransactions, getTransactionsConfig, postTransaction } from "../../controllers/transactions";
import { ConfirmDeletionModal } from "../../components/ConfirmDeletionModal";
import { levels, getPageOrgLevel } from "../../controllers/roles";
import { getOrg } from "../../controllers/org";
import { downloadCsvFile, formatDate } from "../../controllers/utils";
import Loading from "../../components/loading/Loading";
import { useToast } from "../../components/toast/ToastContext";

function TransaccionesComunidad() {
  const params = useParams();
  let level = getPageOrgLevel(params);
  const comunidadId = params.comunidadId;
  
  // Default start date to beginning of current month.
  const fromDate = new Date();
  fromDate.setDate(1);
  const defaultFilters = {
    from: formatDate(fromDate, 'yyyy-mm-dd')
  }
  if (comunidadId && level === levels.comunidad) {
    defaultFilters.comunidadId = comunidadId;
  }

  const [editar, setEditar] = useState(false);
  const [borrarId, setBorrarId] = useState();
  const [transacciones, setTransacciones] = useState([]);
  const [filtros, setFiltros] = useState(defaultFilters);
  const [org, setOrg] = useState();
  const [isDownloading, setIsDownloading] = useState(false);
  const [config, setConfig] = useState();
  const [loaded, setLoaded] = useState(false);
  const [showNewTransaction, setShowNewTransaction] = useState(false);
  const showToast = useToast();

  useEffect(() => {
    loadConfig();
    loadOrg();
    getTransacciones();
  }, [])

  async function loadOrg(){
    let o = await getOrg();
    console.log('org.comunidades: ', o.comunidades);
    setOrg(o);
  }

  const loadConfig = async () => {
    let data = await getTransactionsConfig();
    setConfig(data);
  }

  const getTransacciones = async () => {
    console.log('Filtros', filtros);
    if (!filtros.comunidadId) {
      return;
    }

    const t = await getTransactions(filtros);
    setTransacciones(t.transactions);
    setLoaded(true);
  }

  const guardarTransaccion = async (i, t) => {
    console.log(i, t);
    try {
      await postTransaction(t);
      if (!i) {
        showToast({
          message: 'Se creó la transacción con éxito.',
          bg: 'success',
          autohide: true,
          delay: 7000,
          title: 'Transacción creada'
        });
      }
    }
    catch(e) {
      showToast({
        message: 'Ocurrió un error al crear la transacción. Por favor intenta de nuevo más tarde.',
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error al guardar transacción'
      });
    }
    
    await getTransacciones();
    setShowNewTransaction(false);
    setEditar(false);
  }

  const cancelDelete = () => {
    setBorrarId(null);
  }
  const confirmDelete = async () => {
    await deleteTransaction(borrarId, comunidadId);
    setBorrarId(null);
    await getTransacciones();
    setEditar(false);
  }

  const updateFilters = (key, value) => {
    let newFilters = {...filtros};
    if (value === 'all') {
      delete newFilters[key];
    }
    else {
      newFilters[key] = value;
    }
    setFiltros(newFilters);
  }

  const submitFilters = (ev) => {
    ev.preventDefault();
    getTransacciones();
  }

  async function download() {
    if (isDownloading) {
      return;
    }
    try {
      let csvContent = 'ID,Fecha,Comunidad,Descripción,Tipo,"Tipo de Gasto","Num de Cheque",Monto,Reconciliado,Categoría,"Fecha de creación","Fecha de última actualización"\n';
      transacciones.forEach(t => {
        if (t.type !== 'balance') {
          csvContent += `${t.transaction_id},${t.date},"${org.comunidades.filter(c => c.comunidad_id === t.comunidad_id)[0].label}","${t.description}",${t.type},${t.expense_type},${t.check_number},${t.amount},${t.reconciled},"${config.categories.filter(c => c.transaction_category_id === t.transaction_category_id)[0].label}",${t.createdAt},${t.updatedAt}\n`
        }
      });
      
      setIsDownloading(true);
      downloadCsvFile('tesoreria-transacciones.csv', csvContent);
      setIsDownloading(false);
    }
    catch (e) {
      setIsDownloading(false);
    }
  }

  function renderDiocesisOptions() {
    if (!filtros.regionId) {
      return [
        <option value={null} key={`filter-diocesis-null`}>-- Selecciona una región --</option>
      ]
    }
    let d = org.diocesis.filter(d => d.region_id === filtros.regionId);
    d.unshift({ value: null, label: '-- Selecciona una diócesis -- '});
    return d.map(d => <option value={d.diocesis_id} key={`filter-diocesis-${d.diocesis_id}`}>{d.label}</option> );
  }

  function renderComunidadOptions() {
    if (!filtros.regionId) {
      return [
        <option value={null} key={`filter-comunidad-null-1`}>-- Selecciona una región --</option>
      ];
    }
    if (!filtros.diocesisId) {
      return [
        <option value={null} key={`filter-comunidad-null-2`}>-- Selecciona una diócesis --</option>
      ];
    }
    let c = org.comunidades.filter(c => c.diocesis_id === filtros.diocesisId);
    c.unshift({ value: null, label: '-- Selecciona una comunidad -- '});
    return c.map(c => <option value={c.comunidad_id} key={`filter-comunidad-${c.comunidad_id}`}>{c.label}</option> );
  }

  const renderTransacciones = () => {
    let balance = 0;
    return <table>
        <thead>
          <tr>
            <td>Fecha</td>
            <td>Tipo</td>
            <td>Beneficiario</td>
            <td>Descripción</td>
            <td>Reconciliado</td>
            <td>Monto</td>
            <td>Balance</td>
            <td>Acciones</td>
          </tr>
        </thead>
        <tbody>
          {
            transacciones.length > 0 && transacciones.map((t, i) => {
              if (t.type === 'deposito') {
                balance += parseFloat(t.amount);
              } 
              else if (t.type === 'gasto') {
                balance -= parseFloat(t.amount);
              }
              else {
                balance += parseFloat(t.amount);
              }

              return <>
                <tr key={'transaccion-' + t.transaction_id}>
                  <td>{t.date}</td>
                  <td>{t.type === 'deposito' ? 'Depósito' : t.type === 'balance' ? 'Balance' : 'Gasto'}</td>
                  <td>{t.beneficiary}</td>
                  <td>{t.description}</td>
                  <td>{t.reconciled ? 'Sí' : 'No'}</td>
                  <td><span className={t.type === 'gasto' ? 'text-danger' : ''}>${parseFloat(t.amount).toFixed(2)}</span></td>
                  <td>{(!filtros.type && !filtros.reconciled) && `$${balance.toFixed(2)}`}</td>
                  <td>
                    {t.type !== 'balance' && <>
                      <a onClick={e => {e.preventDefault(); setEditar(t.transaction_id)}} href="#" className="me-2">Editar</a> 
                      <a onClick={e => {e.preventDefault(); setBorrarId(t.transaction_id)}} href="#" className="text-danger">Borrar</a>
                    </>}
                  </td>
                </tr>
                <tr className={editar !== t.transaction_id ? 'd-none': ''} key={'transaccion-editar-' + t.transaction_id}>
                  <td colSpan={8}><Transaccion {...t} transactionId={t.transaction_id} comunidadId={comunidadId} cancelar={setEditar} guardar={guardarTransaccion} /></td>
                </tr>
              </>
            })
          }
        </tbody>
      </table>;
  }

  if (!org || !config) {
    return <Container className="transacciones">
      <Row>
        <Loading />
      </Row>
    </Container>
  }

  return (
    <div>
      <Container className="transacciones">
        <Row>
          <h2>Transacciones</h2>
        </Row>
        {level === levels.comunidad &&
          <Modal show={showNewTransaction} size="xl" centered>
            <Modal.Header>Capturar nueva transacción</Modal.Header>
            <Modal.Body>
              <Transaccion comunidadId={comunidadId} guardar={guardarTransaccion} key={`transaccion-nueva-${transacciones.length}`} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={e => setShowNewTransaction(false)}>
                Cancelar
              </Button>
            </Modal.Footer>
          </Modal>
        }
        <Row className="mb-3 mt-3">
            <Col style={{textAlign: 'right'}}>
              {level === levels.comunidad && 
                <Button onClick={e => setShowNewTransaction(true)} className="me-4">Capturar Nueva Transacción</Button>
              }
              { transacciones.length > 0 && 
                <Button onClick={download} variant="secondary">{isDownloading ? 'Descargando...' : 'Descargar'}</Button>
              }
            </Col>
        </Row>
        <Row>
          <Row className="mt-4 mb-4">
            <Col>
              <Card>
                <Card.Body>
                  <Form onSubmit={submitFilters}>
                    <Row>
                      {level < levels.region && <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Región</Form.Label>
                          <Form.Select name='region' onChange={e => updateFilters('regionId', parseInt(e.target.value))}>
                            <option value={null}>-- Selecciona una región --</option>
                            { org.regiones.map(r => <option value={r.region_id} key={`filter-region-${r.region_id}`}>{r.label}</option>) }
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      }
                      {level < levels.diocesis && <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Diócesis</Form.Label>
                          <Form.Select name='diocesis' onChange={e => updateFilters('diocesisId', parseInt(e.target.value))}>
                            { renderDiocesisOptions() }
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      }
                      {level < levels.comunidad  && <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Comunidad</Form.Label>
                          <Form.Select name='comunidad' onChange={e => updateFilters('comunidadId', parseInt(e.target.value))}>
                            { renderComunidadOptions() }
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      }
                    </Row>
                    <Row>
                      <Col md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label>Fecha Inicio</Form.Label>
                          <Form.Control type="date" onChange={e => updateFilters('from', e.target.value)} value={filtros.from}></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label>Fecha Final</Form.Label>
                          <Form.Control type="date" onChange={e => updateFilters('to', e.target.value)} value={filtros.to}></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label>Tipo</Form.Label>
                          <Form.Select name='type' onChange={e => updateFilters('type', e.target.value)}>
                            <option value='all'>-- Selecciona un tipo de transacción --</option>
                            <option value='deposito'>Depósito</option>
                            <option value='gasto'>Gasto</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label>Reconciliado</Form.Label>
                          <Form.Select name='reconciled' onChange={e => updateFilters('reconciled', e.target.value)}>
                            <option value='all'>-- Transacción reconciliada --</option>
                            <option value='no'>No</option>
                            <option value='si'>Sí</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <Button type="submit" variant="primary">Actualizar</Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          { !filtros.comunidadId && <p>Selecciona una comunidad.</p>}
          { loaded && filtros.comunidadId && transacciones.length === 0 && <p>No hay transacciones.</p> }
          { loaded && filtros.comunidadId && transacciones.length > 0 && renderTransacciones() }
        </Row>
      </Container>
      <ConfirmDeletionModal
        show={!!borrarId}
        handleClose={cancelDelete}
        title={`Borrar transacción`}
        triggerDelete={confirmDelete}
      />
    </div>
  );
}

export default TransaccionesComunidad;
